import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexRibbon',
  setup(__props) {

const LeftRibbons = defineAsyncComponent(() => import("@/components/theme/advance/ribbons/LeftRibbons.vue"))
const RightRibbons = defineAsyncComponent(() => import("@/components/theme/advance/ribbons/RightRibbons.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(LeftRibbons)),
    _createVNode(_unref(RightRibbons))
  ]))
}
}

})